import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API } from '../api';
import Layout from '../components/Layout';

const BASE_URL = 'http://192.168.0.57:5000';
const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
  @keyframes fadeSlideIn{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
  @keyframes modalIn{from{opacity:0;transform:scale(0.94) translateY(16px)}to{opacity:1;transform:scale(1) translateY(0)}}
  @keyframes spin{to{transform:rotate(360deg)}}
  @keyframes shimmer{0%{background-position:-600px 0}100%{background-position:600px 0}}
  @keyframes pulse{0%,100%{box-shadow:0 0 0 0 rgba(99,102,241,0.4)}50%{box-shadow:0 0 0 8px rgba(99,102,241,0)}}
  *{box-sizing:border-box}
  .lc-root{font-family:'DM Sans',sans-serif;animation:fadeSlideIn 0.5s ease both}

  .lc-input{width:100%;padding:12px 16px;background:#f5f3ff;border:1.5px solid #ddd6fe;
    border-radius:12px;color:#1a1d2e;font-size:14px;font-family:'DM Sans',sans-serif;
    outline:none;transition:border-color 0.2s,box-shadow 0.2s,background 0.2s}
  .lc-input:focus{border-color:#6366f1;background:#fff;box-shadow:0 0 0 3px rgba(99,102,241,0.15)}
  .lc-input::placeholder{color:#a0aec0}

  .lc-textarea{width:100%;padding:12px 16px;background:#f5f3ff;border:1.5px solid #ddd6fe;
    border-radius:12px;color:#1a1d2e;font-size:14px;font-family:'DM Sans',sans-serif;
    outline:none;resize:vertical;min-height:160px;line-height:1.7;
    transition:border-color 0.2s,box-shadow 0.2s,background 0.2s}
  .lc-textarea:focus{border-color:#6366f1;background:#fff;box-shadow:0 0 0 3px rgba(99,102,241,0.15)}
  .lc-textarea::placeholder{color:#a0aec0}

  .lc-btn-primary{padding:12px 28px;background:linear-gradient(135deg,#818cf8,#6366f1);
    border:none;border-radius:12px;color:#fff;font-size:14px;font-weight:700;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:transform 0.15s,box-shadow 0.15s;
    display:inline-flex;align-items:center;gap:8px;animation:pulse 2.5s ease-in-out infinite}
  .lc-btn-primary:hover{transform:translateY(-2px);box-shadow:0 8px 24px rgba(99,102,241,0.4);animation:none}
  .lc-btn-primary:disabled{opacity:0.6;cursor:not-allowed;animation:none;transform:none}
  .lc-btn-secondary{padding:11px 24px;background:#f5f3ff;border:1.5px solid #ddd6fe;
    border-radius:12px;color:#4338ca;font-size:14px;font-weight:600;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:all 0.15s}
  .lc-btn-secondary:hover{background:#ede9fe;border-color:#6366f1}

  .lc-row:hover td{background:#f5f3ff !important;transition:background 0.15s}
  .action-btn{width:34px;height:34px;border:none;border-radius:9px;cursor:pointer;font-size:15px;
    display:inline-flex;align-items:center;justify-content:center;transition:transform 0.15s,box-shadow 0.15s}
  .action-btn:hover{transform:scale(1.18);box-shadow:0 4px 14px rgba(0,0,0,0.15)}

  .skeleton{background:linear-gradient(90deg,#f5f3ff 25%,#ede9fe 50%,#f5f3ff 75%);
    background-size:600px 100%;animation:shimmer 1.5s infinite;border-radius:6px}

  .nav-item{display:flex;align-items:center;gap:12px;padding-top:11px;padding-bottom:11px;
    padding-left:16px;padding-right:16px;cursor:pointer;border-radius:10px;margin:2px 10px;
    color:#aaa;font-size:14px;transition:all 0.15s;white-space:nowrap}
  .nav-item:hover{background:rgba(255,255,255,0.05);color:#fff}
  .nav-item.active{background:rgba(99,102,241,0.15);color:#818cf8;border-left:3px solid #818cf8;padding-left:13px}

  .lc-label{font-size:11px;font-weight:700;color:#4338ca;text-transform:uppercase;
    letter-spacing:0.5px;margin-bottom:6px;display:block}

  .badge{padding:4px 12px;border-radius:20px;font-size:12px;font-weight:600;display:inline-block}

  .upload-zone{border:2px dashed #ddd6fe;border-radius:14px;padding:20px;text-align:center;
    cursor:pointer;transition:all 0.2s;background:#f5f3ff;position:relative;overflow:hidden}
  .upload-zone:hover{border-color:#6366f1;background:#ede9fe}
  .upload-zone.has-file{border-color:#6366f1;background:#ede9fe;border-style:solid}
  .upload-zone input[type=file]{position:absolute;inset:0;opacity:0;cursor:pointer;width:100%;height:100%}

  .search-box{padding:9px 14px 9px 38px;border:1.5px solid #ddd6fe;border-radius:20px;
    background:#fff;font-size:13px;outline:none;width:220px;
    transition:border-color 0.2s,width 0.3s;color:#1a1d2e;font-family:'DM Sans',sans-serif}
  .search-box:focus{border-color:#6366f1;box-shadow:0 0 0 3px rgba(99,102,241,0.12);width:280px}

  .modal-scroll{overflow-y:auto;flex:1;padding:0 28px 20px}
  .modal-scroll::-webkit-scrollbar{width:5px}
  .modal-scroll::-webkit-scrollbar-thumb{background:#ddd6fe;border-radius:3px}

  .content-preview{background:#f5f3ff;border-radius:12px;padding:16px 18px;
    border:1.5px solid #ddd6fe;font-size:14px;line-height:1.75;color:#374151;
    max-height:300px;overflow-y:auto;white-space:pre-wrap;word-break:break-word}
  .content-preview::-webkit-scrollbar{width:4px}
  .content-preview::-webkit-scrollbar-thumb{background:#c4b5fd;border-radius:2px}

  .card-content{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;
    overflow:hidden;font-size:13px;color:#6b7280;line-height:1.5;margin-top:4px}

  .view-content-btn{padding:5px 12px;border:1.5px solid #ddd6fe;border-radius:20px;
    background:#f5f3ff;color:#4338ca;font-size:12px;font-weight:600;cursor:pointer;
    font-family:'DM Sans',sans-serif;transition:all 0.18s;white-space:nowrap}
  .view-content-btn:hover{background:#6366f1;border-color:#6366f1;color:#fff}

  .char-count{font-size:11px;color:#a0aec0;text-align:right;margin-top:4px}
  .char-count.warn{color:#f59e0b}
  .char-count.over{color:#ef4444;font-weight:700}
`;



const EMPTY = { titel:'', details:'' };
const MAX_TITLE   = 200;
const MAX_DETAILS = 5000;

export default function LeasingContent() {
  const navigate = useNavigate();
  const location = useLocation();

  const [authUser,  setAuthUser]  = useState(null);
  const [sideOpen,  setSideOpen]  = useState(true);
  const [contents,  setContents]  = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [form,      setForm]      = useState(EMPTY);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [editId,    setEditId]    = useState(null);
  const [saving,    setSaving]    = useState(false);
  const [viewModal, setViewModal] = useState(null);
  const [delModal,  setDelModal]  = useState(null);
  const [delSaving, setDelSaving] = useState(false);
  const [search,    setSearch]    = useState('');
  const [page,      setPage]      = useState(1);
  const [toast,     setToast]     = useState(null);
  const fileRef = useRef();
  const PER = 8;

  useEffect(() => {
    if (!localStorage.getItem('token')) { navigate('/login'); return; }
    setAuthUser(JSON.parse(localStorage.getItem('user') || '{}'));
    fetchContents();
  }, []);

  const fetchContents = async () => {
    setLoading(true);
    try {
      const r = await API.get('/page-content');
      setContents(r.data);
    } catch(e) { showToast('Failed to load page content', 'error'); }
    setLoading(false);
  };

  const showToast = (msg, type='success') => {
    setToast({msg, type});
    setTimeout(() => setToast(null), 3500);
  };

  const resetForm = useCallback(() => {
    setForm(EMPTY);
    setImageFile(null);
    setImagePreview(null);
    setEditId(null);
    if (fileRef.current) fileRef.current.value = '';
  }, []);

  const startEdit = (rec) => {
    setForm({ titel: rec.titel || '', details: rec.details || '' });
    setImagePreview(rec.content_image ? `/${rec.content_image}` : null);
    setImageFile(null);
    setEditId(rec.content_id);
    window.scrollTo({top:0, behavior:'smooth'});
  };

  const handleImageChange = (file) => {
    if (!file) return;
    const allowed = ['image/jpeg','image/png','image/gif'];
    if (!allowed.includes(file.type)) {
      showToast('Only JPG, PNG and GIF files are allowed', 'error'); return;
    }
    if (file.size > 2 * 1024 * 1024) {
      showToast('Image must be under 2MB', 'error'); return;
    }
    setImageFile(file);
    const reader = new FileReader();
    reader.onload = (e) => setImagePreview(e.target.result);
    reader.readAsDataURL(file);
  };

  const handleSubmit = async () => {
    if (!form.titel.trim()) {
      showToast('Title is required', 'error'); return;
    }
    if (form.titel.trim().length > MAX_TITLE) {
      showToast(`Title must be under ${MAX_TITLE} characters`, 'error'); return;
    }
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append('titel',   form.titel.trim());
      fd.append('details', form.details.trim());
      if (imageFile) fd.append('content_image', imageFile);

      if (editId) {
        await API.put(`/page-content/${editId}`, fd, {
          headers: {'Content-Type':'multipart/form-data'}
        });
        showToast('Page content updated ✓');
      } else {
        await API.post('/page-content', fd, {
          headers: {'Content-Type':'multipart/form-data'}
        });
        showToast('Page content added ✓');
      }
      await fetchContents();
      resetForm();
    } catch(e) {
      showToast(e.response?.data?.message || 'Operation failed', 'error');
    }
    setSaving(false);
  };

  const handleDelete = async () => {
    setDelSaving(true);
    try {
      await API.delete(`/page-content/${delModal.content_id}`);
      showToast('Page content deleted ✓');
      setDelModal(null);
      if (editId === delModal.content_id) resetForm();
      await fetchContents();
    } catch(e) {
      showToast(e.response?.data?.message || 'Delete failed', 'error');
    }
    setDelSaving(false);
  };

  const filtered = contents.filter(c => {
    const q = search.toLowerCase();
    return !search || c.titel?.toLowerCase().includes(q) || c.details?.toLowerCase().includes(q);
  });
  const totalPages = Math.ceil(filtered.length / PER);
  const paged      = filtered.slice((page-1)*PER, page*PER);
  const logout     = () => { localStorage.clear(); navigate('/login'); };

  const titleLen   = form.titel.length;
  const detailsLen = form.details.length;

  const fmtDate = (d) => {
    if (!d) return '—';
    return new Date(d).toLocaleDateString('en-IN', {day:'2-digit',month:'short',year:'numeric'});
  };

  const stripHtml = (html) => {
    if (!html) return '';
    return html.replace(/<[^>]*>/g, '').trim();
  };

  const truncate = (str, n) => {
    const clean = stripHtml(str);
    return clean.length > n ? clean.slice(0, n) + '…' : clean;
  };

  return (
    <Layout activePage="User Management">
    <>
      <style>{STYLES}</style>
      <div style={S.root} className="lc-root">

        {/* ── Sidebar ── */}
        {/* <aside style={{...S.sidebar, width: sideOpen?220:68}}>
          <div style={S.sideTop}>
            <div style={S.logoWrap}>
              <div style={S.logoIcon}>🚗</div>
              {sideOpen && <span style={S.logoText}>Orisys</span>}
            </div>
            <button style={S.collapseBtn} onClick={()=>setSideOpen(p=>!p)}>
              {sideOpen?'◀':'▶'}
            </button>
          </div>
          <nav style={{flex:1}}>
            {NAV.map(n=>(
              <div key={n.label}
                className={`nav-item${location.pathname===n.path?' active':''}`}
                onClick={()=>navigate(n.path)}>
                <span style={{fontSize:16,flexShrink:0}}>{n.icon}</span>
                {sideOpen && <span style={{fontWeight:500}}>{n.label}</span>}
              </div>
            ))}
          </nav>
          <div style={S.sideBottom}>
            {sideOpen && (
              <div style={S.userChip}>
                <div style={S.avatar}>{authUser?.user_name?.[0]||'A'}</div>
                <div>
                  <div style={S.uname}>{authUser?.user_name||'Admin'}</div>
                  <div style={S.urole}>Administrator</div>
                </div>
              </div>
            )}
            <button style={S.logoutBtn} onClick={logout}>
              <span>🚪</span>{sideOpen&&<span style={{marginLeft:8}}>Logout</span>}
            </button>
          </div>
        </aside> */}

        {/* ── Main ── */}
        <main>

          {/* Page Header */}
          <div style={S.pageHeader}>
            <div>
              <h1 style={S.pageTitle}>Page Content</h1>
              <p style={S.pageSub}>Manage leasing page content — titles, details and images</p>
            </div>
            <div style={{display:'flex',gap:12}}>
              {[
                {label:'Total Content', value:contents.length, color:'#6366f1', bg:'#f5f3ff', icon:'📝'},
                {label:'With Images',  value:contents.filter(c=>c.content_image).length, color:'#8b5cf6', bg:'#f3eeff', icon:'🖼️'},
              ].map(s=>(
                <div key={s.label} style={{...S.miniStat,background:s.bg}}>
                  <span style={{fontSize:22}}>{s.icon}</span>
                  <div>
                    <div style={{fontSize:22,fontWeight:800,color:s.color,lineHeight:1}}>{s.value}</div>
                    <div style={{fontSize:10,color:'#718096',fontWeight:600,textTransform:'uppercase'}}>{s.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Add / Edit Form ── */}
          <div style={S.formCard}>
            <div style={S.formCardHead}>
              <div style={S.formCardIcon}>{editId?'✏️':'📝'}</div>
              <div style={{flex:1}}>
                <h2 style={S.formCardTitle}>{editId?'Edit Page Content':'Add Page Content'}</h2>
                <p style={S.formCardSub}>
                  {editId
                    ? `Editing: "${contents.find(c=>c.content_id===editId)?.titel}"`
                    : 'Create new leasing page content with title, body text and optional image'}
                </p>
              </div>
              {editId && (
                <button className="lc-btn-secondary" onClick={resetForm}>✕ Cancel</button>
              )}
            </div>

            <div style={{display:'grid',gridTemplateColumns:'1fr 280px',gap:24}}>
              {/* Left — Title + Details */}
              <div style={{display:'flex',flexDirection:'column',gap:16}}>
                <div>
                  <label className="lc-label">Title *</label>
                  <input className="lc-input"
                    placeholder="Enter page content title…"
                    value={form.titel}
                    onChange={e=>setForm(p=>({...p,titel:e.target.value}))}
                    maxLength={MAX_TITLE}/>
                  <div className={`char-count${titleLen>MAX_TITLE*0.9?' warn':''}`}>
                    {titleLen} / {MAX_TITLE}
                  </div>
                </div>
                <div style={{flex:1}}>
                  <label className="lc-label">Content Details</label>
                  <textarea className="lc-textarea"
                    placeholder="Enter full content / description here…"
                    value={form.details}
                    onChange={e=>setForm(p=>({...p,details:e.target.value}))}
                    maxLength={MAX_DETAILS}
                    rows={8}/>
                  <div className={`char-count${detailsLen>MAX_DETAILS*0.9?' warn':''}`}>
                    {detailsLen} / {MAX_DETAILS}
                  </div>
                </div>
              </div>

              {/* Right — Image upload */}
              <div style={{display:'flex',flexDirection:'column',gap:12}}>
                <label className="lc-label">Content Image</label>
                <div className={`upload-zone${imagePreview?' has-file':''}`}
                  style={{flex:imagePreview?'none':1, minHeight:180}}
                  onClick={()=>fileRef.current?.click()}>
                  <input ref={fileRef} type="file"
                    accept="image/jpeg,image/png,image/gif"
                    onChange={e=>handleImageChange(e.target.files[0])}
                    style={{display:'none'}}/>
                  {imagePreview ? (
                    <div>
                      <img src={imagePreview} alt="preview"
                        style={{width:'100%',maxHeight:160,objectFit:'cover',
                          borderRadius:10,marginBottom:8}}/>
                      <div style={{fontSize:12,color:'#6366f1',fontWeight:600}}>
                        Click to replace image
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div style={{fontSize:36,marginBottom:8}}>🖼️</div>
                      <div style={{fontSize:13,color:'#6b7280',fontWeight:500}}>
                        Click to upload image
                      </div>
                      <div style={{fontSize:11,color:'#a0aec0',marginTop:6}}>
                        JPG, PNG, GIF · max 2MB
                      </div>
                    </div>
                  )}
                </div>

                {imagePreview && (
                  <button
                    style={{padding:'8px',border:'1.5px solid #fca5a5',borderRadius:10,
                      background:'#fef2f2',color:'#dc2626',fontSize:12,fontWeight:600,
                      cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}
                    onClick={()=>{setImageFile(null);setImagePreview(null);if(fileRef.current)fileRef.current.value='';}}>
                    🗑 Remove Image
                  </button>
                )}

                {/* Info box */}
                <div style={{background:'#f5f3ff',borderRadius:12,padding:'12px 14px',
                  border:'1px solid #ddd6fe',fontSize:12,color:'#4338ca',lineHeight:1.6}}>
                  <strong>Tips:</strong><br/>
                  • Use a clear, descriptive title<br/>
                  • Keep content concise and readable<br/>
                  • Recommended image: 800×500px
                </div>
              </div>
            </div>

            {/* Submit */}
            <div style={{display:'flex',gap:12,marginTop:20,justifyContent:'flex-end',
              borderTop:'1px solid #ede9fe',paddingTop:16}}>
              {editId && <button className="lc-btn-secondary" onClick={resetForm}>Cancel</button>}
              <button className="lc-btn-primary" onClick={handleSubmit} disabled={saving}>
                {saving
                  ? <span style={S.spinner}/>
                  : editId ? '💾 Update Content' : '＋ Add Content'}
              </button>
            </div>
          </div>

          {/* ── Content List ── */}
          <div style={S.tableCard}>
            <div style={S.tableCardHead}>
              <h3 style={S.tableCardTitle}>📋 Manage Page Content</h3>
              <div style={{display:'flex',gap:10,alignItems:'center'}}>
                <div style={{position:'relative'}}>
                  <span style={{position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',
                    color:'#a0aec0',fontSize:14,pointerEvents:'none'}}>🔍</span>
                  <input className="search-box" placeholder="Search title or content…"
                    value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}}/>
                </div>
                <span style={{fontSize:12,background:'#f5f3ff',color:'#6366f1',
                  borderRadius:20,padding:'4px 14px',fontWeight:700,whiteSpace:'nowrap'}}>
                  {filtered.length} entries
                </span>
              </div>
            </div>

            {/* Card grid layout */}
            {loading ? (
              <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))',
                gap:16,padding:'20px 24px'}}>
                {Array.from({length:6}).map((_,i)=>(
                  <div key={i} style={{borderRadius:14,overflow:'hidden',border:'1.5px solid #ede9fe'}}>
                    <div className="skeleton" style={{height:140}}/>
                    <div style={{padding:'14px'}}>
                      <div className="skeleton" style={{height:14,width:'70%',marginBottom:8}}/>
                      <div className="skeleton" style={{height:12,width:'90%',marginBottom:6}}/>
                      <div className="skeleton" style={{height:12,width:'60%'}}/>
                    </div>
                  </div>
                ))}
              </div>
            ) : paged.length === 0 ? (
              <div style={{textAlign:'center',padding:'56px 0',color:'#a0aec0'}}>
                <div style={{fontSize:48,marginBottom:12}}>📝</div>
                <div style={{fontSize:16,fontWeight:600}}>No page content found</div>
                <div style={{fontSize:13,marginTop:6}}>Use the form above to add your first content entry</div>
              </div>
            ) : (
              <div style={{display:'grid',
                gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))',
                gap:16,padding:'20px 24px'}}>
                {paged.map((c,i)=>(
                  <div key={c.content_id}
                    style={{borderRadius:16,overflow:'hidden',
                      border:`1.5px solid ${editId===c.content_id?'#6366f1':'#ede9fe'}`,
                      background:'#fff',boxShadow:'0 2px 12px rgba(99,102,241,0.06)',
                      transition:'transform 0.2s,box-shadow 0.2s',
                      transform:editId===c.content_id?'translateY(-2px)':'none'}}>
                    {/* Image */}
                    <div style={{height:140,background:'linear-gradient(135deg,#f5f3ff,#ede9fe)',
                      display:'flex',alignItems:'center',justifyContent:'center',
                      overflow:'hidden',position:'relative'}}>
                      {c.content_image ? (
                        <img src={`${BASE_URL}/${c.content_image}`} alt={c.titel}
                          style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                      ) : (
                        <div style={{textAlign:'center'}}>
                          <div style={{fontSize:36,opacity:0.3}}>🖼️</div>
                          <div style={{fontSize:11,color:'#a0aec0',marginTop:4}}>No image</div>
                        </div>
                      )}
                      {/* Serial badge */}
                      <div style={{position:'absolute',top:8,left:8,
                        background:'rgba(99,102,241,0.9)',color:'#fff',
                        borderRadius:20,padding:'2px 10px',fontSize:11,fontWeight:700}}>
                        #{(page-1)*PER+i+1}
                      </div>
                      {editId===c.content_id && (
                        <div style={{position:'absolute',top:8,right:8,
                          background:'#fef9c3',color:'#854d0e',
                          borderRadius:20,padding:'2px 8px',fontSize:10,fontWeight:700}}>
                          EDITING
                        </div>
                      )}
                    </div>

                    {/* Content */}
                    <div style={{padding:'14px 16px'}}>
                      <div style={{fontWeight:700,fontSize:14,color:'#1a1d2e',
                        marginBottom:4,lineHeight:1.3}}>
                        {c.titel}
                      </div>
                      {c.details && (
                        <div style={{fontSize:12,color:'#6b7280',lineHeight:1.5,
                          display:'-webkit-box',WebkitLineClamp:2,
                          WebkitBoxOrient:'vertical',overflow:'hidden',marginBottom:10}}>
                          {stripHtml(c.details)}
                        </div>
                      )}
                      {c.create_date && (
                        <div style={{fontSize:10,color:'#a0aec0',marginBottom:10}}>
                          📅 {fmtDate(c.create_date)}
                        </div>
                      )}

                      {/* Actions */}
                      <div style={{display:'flex',gap:6,alignItems:'center'}}>
                        <button className="view-content-btn"
                          onClick={()=>setViewModal(c)}>👁 View</button>
                        <button className="action-btn"
                          style={{background:'#fefcbf',color:'#744210',marginLeft:'auto'}}
                          title="Edit" onClick={()=>startEdit(c)}>✏️</button>
                        <button className="action-btn"
                          style={{background:'#fff5f5',color:'#c53030'}}
                          title="Delete" onClick={()=>setDelModal(c)}>🗑</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Pagination */}
            {totalPages > 1 && (
              <div style={{...S.pagination,borderTop:'1px solid #f5f3ff'}}>
                <span style={{fontSize:13,color:'#718096'}}>
                  Showing {(page-1)*PER+1}–{Math.min(page*PER,filtered.length)} of {filtered.length}
                </span>
                <div style={{display:'flex',gap:6}}>
                  <button style={S.pageBtn} disabled={page===1} onClick={()=>setPage(p=>p-1)}>← Prev</button>
                  {Array.from({length:totalPages},(_,i)=>i+1).map(p=>(
                    <button key={p} style={{...S.pageBtn,...(p===page?S.pageBtnActive:{})}}
                      onClick={()=>setPage(p)}>{p}</button>
                  ))}
                  <button style={S.pageBtn} disabled={page===totalPages} onClick={()=>setPage(p=>p+1)}>Next →</button>
                </div>
              </div>
            )}
          </div>
        </main>

        {/* ── View Modal ── */}
        {viewModal && (
          <div style={S.overlay} onClick={()=>setViewModal(null)}>
            <div style={{...S.modal,maxWidth:580}} onClick={e=>e.stopPropagation()}>
              <div style={S.modalHead}>
                <div style={{flex:1,paddingRight:12}}>
                  <h2 style={{...S.modalTitle,fontSize:18,lineHeight:1.3}}>{viewModal.titel}</h2>
                  {viewModal.create_date && (
                    <p style={S.modalSub}>Added on {fmtDate(viewModal.create_date)}</p>
                  )}
                </div>
                <button style={S.xBtn} onClick={()=>setViewModal(null)}>✕</button>
              </div>
              <div className="modal-scroll" style={{padding:'16px 28px 20px'}}>
                {/* Image */}
                {viewModal.content_image && (
                  <div style={{borderRadius:14,overflow:'hidden',
                    border:'1.5px solid #ddd6fe',marginBottom:18,
                    maxHeight:240,display:'flex',alignItems:'center',justifyContent:'center',
                    background:'#f5f3ff'}}>
                    <img src={`/${viewModal.content_image}`} alt={viewModal.titel}
                      style={{width:'100%',maxHeight:240,objectFit:'cover'}}/>
                  </div>
                )}

                {/* Details */}
                <div style={{marginBottom:8,fontSize:11,fontWeight:700,color:'#4338ca',
                  textTransform:'uppercase',letterSpacing:'0.5px'}}>
                  Content Details
                </div>
                {viewModal.details ? (
                  <div className="content-preview"
                    dangerouslySetInnerHTML={{__html: viewModal.details.replace(/\n/g,'<br/>')}}/>
                ) : (
                  <div style={{textAlign:'center',padding:'24px',color:'#a0aec0',
                    background:'#f5f3ff',borderRadius:12,fontSize:13}}>
                    No content details added
                  </div>
                )}
              </div>
              <div style={S.modalFoot}>
                <button className="lc-btn-secondary" onClick={()=>setViewModal(null)}>Close</button>
                <button className="lc-btn-primary" style={{animation:'none'}}
                  onClick={()=>{setViewModal(null);setTimeout(()=>startEdit(viewModal),100);}}>
                  ✏️ Edit Content
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Delete Modal ── */}
        {delModal && (
          <div style={S.overlay} onClick={()=>setDelModal(null)}>
            <div style={{...S.modal,maxWidth:420}} onClick={e=>e.stopPropagation()}>
              <div style={{padding:'36px 32px',textAlign:'center'}}>
                <div style={{fontSize:52,marginBottom:16}}>🗑️</div>
                <h2 style={{fontSize:20,fontWeight:800,color:'#1a1d2e',marginBottom:8}}>
                  Delete Content?
                </h2>
                <div style={{marginBottom:16}}>
                  <span className="badge" style={{background:'#f5f3ff',color:'#6366f1',
                    fontSize:13,padding:'6px 16px'}}>
                    📝 {delModal.titel}
                  </span>
                </div>
                {delModal.content_image && (
                  <div style={{fontSize:12,color:'#f97316',marginBottom:12,
                    background:'#fff7ed',borderRadius:8,padding:'8px 12px',
                    border:'1px solid #fed7aa'}}>
                    ⚠️ The associated image will also be permanently deleted.
                  </div>
                )}
                <p style={{color:'#718096',fontSize:14,lineHeight:1.7,marginBottom:28}}>
                  Are you sure you want to delete this page content?<br/>
                  <strong style={{color:'#e53e3e'}}>This action cannot be undone.</strong>
                </p>
                <div style={{display:'flex',gap:12,justifyContent:'center'}}>
                  <button className="lc-btn-secondary" onClick={()=>setDelModal(null)}>Cancel</button>
                  <button disabled={delSaving} onClick={handleDelete} style={{
                    padding:'12px 24px',background:'linear-gradient(135deg,#fc8181,#e53e3e)',
                    border:'none',borderRadius:12,color:'#fff',fontWeight:700,fontSize:14,
                    fontFamily:'DM Sans,sans-serif',cursor:'pointer',
                    display:'flex',alignItems:'center',gap:8}}>
                    {delSaving?<span style={S.spinner}/>:'🗑️ Delete Permanently'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Toast ── */}
        {toast && (
          <div style={{...S.toast,
            background:toast.type==='error'?'#fff5f5':'#f5f3ff',
            borderColor:toast.type==='error'?'#fc8181':'#818cf8',
            color:toast.type==='error'?'#c53030':'#4338ca'}}>
            {toast.type==='error'?'⚠️':'✅'} {toast.msg}
          </div>
        )}
      </div>
    </>
    </Layout>
  );
}

/* ─── Styles ─── */
const S = {
  root:{display:'flex',minHeight:'100vh',background:'#faf8ff'},
//   sidebar:{background:'#1a1d2e',color:'#fff',display:'flex',flexDirection:'column',
//     position:'fixed',height:'100vh',transition:'width 0.25s',overflow:'hidden',zIndex:100},
//   sideTop:{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'20px 16px 16px'},
//   logoWrap:{display:'flex',alignItems:'center',gap:10},
//   logoIcon:{width:36,height:36,background:'linear-gradient(135deg,#818cf8,#6366f1)',borderRadius:10,
//     display:'flex',alignItems:'center',justifyContent:'center',fontSize:18,flexShrink:0},
//   logoText:{fontSize:18,fontWeight:800,letterSpacing:'-0.5px',whiteSpace:'nowrap',fontFamily:"'Syne',sans-serif"},
//   collapseBtn:{background:'rgba(255,255,255,0.08)',border:'none',color:'#aaa',borderRadius:6,
//     padding:'4px 8px',cursor:'pointer',fontSize:11,flexShrink:0},
//   sideBottom:{padding:'16px',borderTop:'1px solid rgba(255,255,255,0.07)'},
//   userChip:{display:'flex',alignItems:'center',gap:10,marginBottom:12},
//   avatar:{width:36,height:36,background:'linear-gradient(135deg,#818cf8,#6366f1)',borderRadius:'50%',
//     display:'flex',alignItems:'center',justifyContent:'center',fontWeight:800,fontSize:15,flexShrink:0},
//   uname:{fontSize:13,fontWeight:700,color:'#fff'},
//   urole:{fontSize:11,color:'#777'},
//   logoutBtn:{width:'100%',background:'rgba(129,140,248,0.12)',border:'1px solid rgba(129,140,248,0.25)',
//     color:'#818cf8',borderRadius:8,padding:'8px 12px',cursor:'pointer',fontSize:13,
//     display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'inherit'},

  main:{flex:1,padding:'28px',minWidth:0},
  pageHeader:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',
    marginBottom:24,flexWrap:'wrap',gap:16},
  pageTitle:{fontSize:26,fontWeight:800,color:'#1a1d2e',letterSpacing:'-0.5px',margin:0,
    fontFamily:"'Syne',sans-serif"},
  pageSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  miniStat:{display:'flex',alignItems:'center',gap:12,borderRadius:14,padding:'14px 18px',
    boxShadow:'0 2px 10px rgba(0,0,0,0.05)'},

  formCard:{background:'#fff',borderRadius:20,padding:'28px',
    boxShadow:'0 4px 24px rgba(99,102,241,0.08)',marginBottom:24,border:'1.5px solid #ddd6fe'},
  formCardHead:{display:'flex',alignItems:'flex-start',gap:16,marginBottom:22},
  formCardIcon:{width:48,height:48,background:'linear-gradient(135deg,#818cf8,#6366f1)',
    borderRadius:14,display:'flex',alignItems:'center',justifyContent:'center',
    fontSize:22,flexShrink:0,boxShadow:'0 4px 14px rgba(99,102,241,0.3)'},
  formCardTitle:{fontSize:18,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  formCardSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},

  tableCard:{background:'#fff',borderRadius:20,overflow:'hidden',
    boxShadow:'0 4px 24px rgba(99,102,241,0.08)',marginBottom:20,border:'1.5px solid #ddd6fe'},
  tableCardHead:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'20px 24px',borderBottom:'1px solid #f5f3ff',flexWrap:'wrap',gap:12},
  tableCardTitle:{fontSize:16,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},

  pagination:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'16px 24px'},
  pageBtn:{padding:'6px 12px',border:'1.5px solid #ddd6fe',borderRadius:8,background:'#fff',
    color:'#6366f1',fontSize:13,fontWeight:600,cursor:'pointer',
    fontFamily:'DM Sans,sans-serif',transition:'all 0.15s'},
  pageBtnActive:{background:'#6366f1',borderColor:'#6366f1',color:'#fff'},

  overlay:{position:'fixed',inset:0,background:'rgba(5,0,30,0.6)',zIndex:200,
    display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(4px)',padding:'20px'},
  modal:{background:'#fff',borderRadius:20,width:'100%',maxWidth:620,maxHeight:'90vh',
    display:'flex',flexDirection:'column',
    boxShadow:'0 32px 80px rgba(99,102,241,0.2)',animation:'modalIn 0.3s ease both'},
  modalHead:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',
    padding:'24px 28px 0',flexShrink:0},
  modalTitle:{fontSize:20,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  modalSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  modalFoot:{display:'flex',gap:12,justifyContent:'flex-end',
    padding:'16px 28px',borderTop:'1px solid #f5f3ff',flexShrink:0},
  xBtn:{background:'rgba(129,140,248,0.15)',border:'none',color:'#6366f1',borderRadius:'50%',
    width:32,height:32,cursor:'pointer',fontWeight:800,fontSize:14,
    display:'flex',alignItems:'center',justifyContent:'center'},
  spinner:{display:'inline-block',width:16,height:16,border:'2px solid rgba(255,255,255,0.3)',
    borderTopColor:'#fff',borderRadius:'50%',animation:'spin 0.6s linear infinite'},
  toast:{position:'fixed',bottom:28,right:28,zIndex:999,padding:'14px 22px',
    borderRadius:12,border:'1.5px solid',fontSize:14,fontWeight:600,
    fontFamily:'DM Sans,sans-serif',boxShadow:'0 8px 24px rgba(0,0,0,0.12)',
    animation:'fadeSlideIn 0.3s ease'},
};